import React, { FunctionComponent, useState, useEffect, useCallback } from 'react';
import { getCsrfToken } from '../../../libs/csrfToken';
import {
  getFollowers,
  getIsFollowed,
  executeFollow,
  executeUnFollow,
} from '../../../services/personCompanyRelationships';
import { Presentation } from './presentation';
import type { Props } from './types';
import { useLoginRegisterModals } from '../../../hooks/useLoginRegisterModals';

export const Component: FunctionComponent<Props> = (props) => {
  const [classNames, setClassNames] = useState({
    click: '',
    clicked: '',
    num: '',
  });
  const [followValue, setFollowValue] = useState('フォローする');
  const [followed, setFollowed] = useState(false);
  const [isShow, setIsShow] = useState(true);
  const [followers, setFollowers] = useState(0);

  const {
    isLoginModalOpen,
    isRegisterModalOpen,
    handleToggleLoginModal,
    handleToggleRegisterModal,
    handleChangeModal,
    redirectUrl,
    isRecruitmentOrEventOrTvOrCompanyPath
  } = useLoginRegisterModals(false);

  const fetchFollowers = useCallback(async () => {
    try {
      const data = await getFollowers(props.company_id);
      setFollowers(data.followers);
    } catch (error) {
      console.error('Error fetching followers:', error);
    }
  }, [props.company_id]);

  const fetchIsFollowed = useCallback(async () => {
    try {
      const data = await getIsFollowed(props.company_id);
      setFollowed(data.is_followed);
      setClassNames((prev) => ({
        ...prev,
        click: data.is_followed ? prev.clicked : prev.click,
      }));
      setFollowValue(data.is_followed ? 'フォロー中' : 'フォローする');
    } catch (error) {
      console.error('Error fetching follow status:', error);
      setClassNames((prev) => ({ ...prev, click: prev.click }));
    }
  }, [props.company_id]);

  useEffect(() => {
    let clickClass = '';
    let clickedClass = '';
    let numClass = '';
    let show = true;

    if (props.page === 'companyShow') {
      clickClass = 'company-info-page-profile-follow-btn';
      clickedClass = 'company-info-page-profile-follow-btn-clicked';
      numClass = 'company-info-page-profile-follow-num';
      show = false;
    } else if (props.page === 'stopRecruitment') {
      clickClass = 'recruitment__show__follow__btn';
      clickedClass = 'recruitment__show__follow__btn__clicked';
      numClass = 'recruitment__show__follow__btn__num';
      show = true;
    } else {
      clickClass = 'company-index-card-follow-btn';
      clickedClass = 'company-index-card-follow-btn-clicked';
      numClass = 'company-index-card-follow-num';
      show = true;
    }

    setClassNames({ click: clickClass, clicked: clickedClass, num: numClass });
    setIsShow(show);

    fetchFollowers();
    fetchIsFollowed();
  }, [props.page, props.company_id, fetchFollowers, fetchIsFollowed]); // 依存配列にフェッチ関数を含める

  const handleSave = useCallback(async () => {
    const csrfToken = getCsrfToken();
    try {
      await executeFollow({
        csrfToken,
        body: JSON.stringify({ company_id: props.company_id }),
      });
      setFollowed(true);
      setFollowValue('フォロー中');
      setClassNames((prev) => ({ ...prev, click: prev.clicked }));
      fetchFollowers();
    } catch (error) {
      console.error('Error saving follow:', error);
      window.alert('求職者アカウントでログインされてません。');
    }
  }, [props.company_id, getCsrfToken, fetchFollowers]);

  const handleDelete = useCallback(async () => {
    const csrfToken = getCsrfToken();
    try {
      await executeUnFollow({
        csrfToken,
        companyId: props.company_id,
      });
      setFollowed(false);
      setFollowValue('フォローする');
      setClassNames((prev) => ({ ...prev, click: prev.click })); // ボタンのクラスを更新
      fetchFollowers();
    } catch (error) {
      console.error('Error deleting follow:', error);
    }
  }, [props.company_id, getCsrfToken, fetchFollowers]);

  const handleClick = useCallback(() => {
    if (props.user === 'without_login') {
      if (props.page === 'stopRecruitment') {
        handleToggleLoginModal();
      } else {
        handleToggleRegisterModal();
      }
      return;
    }

    if (followed) {
      handleDelete();
    } else {
      handleSave();
    }
  }, [props.page, props.user, followed, handleDelete, handleSave]);

  const presentationProps = {
    ...props,
    followed,
    followers,
    followValue,
    isShow,
    classNames,
    isLoginModalOpen,
    isRegisterModalOpen,
    redirectUrl,
    handleClick,
    handleToggleLoginModal,
    handleToggleRegisterModal,
    handleChangeModal,
    isRecruitmentOrEventOrTvOrCompanyPath,
  };

  return <Presentation {...presentationProps} />;
};
